import { CashResponse, CashResponseMiddleware } from '@cash-web/shared-util-fetch'

import { FlowResponse, FlowStateDispatch } from '../utils'

export const createSetClientScenarioMiddleware =
  ({ state, dispatch }: FlowStateDispatch): CashResponseMiddleware =>
  (response: CashResponse<FlowResponse>, context) => {
    const responseContext = response?.response_context ?? {}
    const clientScenario = response.client_scenario
    const blockerDescriptors = responseContext?.scenario_plan?.blocker_descriptors

    // guard
    if (clientScenario == null || clientScenario === state.clientScenario || blockerDescriptors != null) {
      return response
    }

    // action
    dispatch({
      type: 'SET_CLIENT_SCENARIO',
      clientScenario: clientScenario,
    })

    return response
  }
